import { SelectField } from '@calendly/form';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { useMemo, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { localeSelector } from 'selectors/current_user';
const styledSelectFieldCss = "s5gh5wq";
const StyledSelectField = forwardRef((props, ref) => <SelectField ref={ref} {...props} className={classNames(styledSelectFieldCss, props.className)} />);
const labelCss = "lh93few";
const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
export const durations = [moment.duration(1, 'hours'), moment.duration(4, 'hours'), moment.duration(8, 'hours'), moment.duration(12, 'hours'), moment.duration(24, 'hours'), moment.duration(7, 'days'), moment.duration(14, 'days'), moment.duration(21, 'days')];
export const SessionDurationSelectField = ({
  name,
  label,
  ariaLabel
}) => {
  const userLocale = useSelector(localeSelector);
  const sessionDurationOptions = useMemo(() => durations.map(dur => ({
    id: dur.asSeconds(),
    name: dur.locale(userLocale).humanize()
  })), [userLocale]);
  return <>
      <Label id={ariaLabel}>
        {label}
      </Label>
      <StyledSelectField aria-labelledby={ariaLabel} name={name} options={sessionDurationOptions} />
    </>;
};

require("./session_duration_select_field.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./session_duration_select_field.js");